import { Sort } from '@spike/model';
import { Sorter } from './sorting';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import { appointmentSortColumns } from './groomingSort';
import { bookedAtSorter, clientSorter, petSorter, serviceSorter, statusSorter, totalSorter } from './sorting';

interface AllHeaderTableProps {
    hideClientHeader?: boolean;
    sorter?: Sorter | null;
    onSort?: (sorter: Sorter) => void;
    sort?: Sort | null;
    onServerSort?: (sort: Sort) => void;
}

export const AllHeaderTable: FunctionComponent<AllHeaderTableProps> = props => {
    const serverSort = props.onServerSort !== undefined;

    return (
        <TableHeader>
            {!props.hideClientHeader && (
                <HeaderTableColumn
                    columnSorter={serverSort ? undefined : clientSorter}
                    selectedSorter={props.sorter}
                    sortColumn={serverSort ? appointmentSortColumns.client : undefined}
                    selectedSort={props.sort}
                    onSort={props.onSort}
                    onServerSort={props.onServerSort}
                >
                    Client Name
                </HeaderTableColumn>
            )}
            <HeaderTableColumn
                columnSorter={serverSort ? undefined : petSorter}
                selectedSorter={props.sorter}
                sortColumn={serverSort ? appointmentSortColumns.pet : undefined}
                selectedSort={props.sort}
                onSort={props.onSort}
                onServerSort={props.onServerSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serverSort ? undefined : serviceSorter}
                selectedSorter={props.sorter}
                sortColumn={serverSort ? appointmentSortColumns.service : undefined}
                selectedSort={props.sort}
                onSort={props.onSort}
                onServerSort={props.onServerSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serverSort ? undefined : bookedAtSorter}
                selectedSorter={props.sorter}
                sortColumn={serverSort ? appointmentSortColumns.bookedAt : undefined}
                selectedSort={props.sort}
                onSort={props.onSort}
                onServerSort={props.onServerSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serverSort ? undefined : totalSorter}
                selectedSorter={props.sorter}
                sortColumn={serverSort ? appointmentSortColumns.total : undefined}
                selectedSort={props.sort}
                onSort={props.onSort}
                onServerSort={props.onServerSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serverSort ? undefined : statusSorter}
                selectedSorter={props.sorter}
                sortColumn={serverSort ? appointmentSortColumns.status : undefined}
                selectedSort={props.sort}
                onSort={props.onSort}
                onServerSort={props.onServerSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default AllHeaderTable;
